/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto } from '../../models/platform-api-result-of-data-source-result-dto-of-i-ching-consultation-dto';
import { PlatformDataSourceQuery } from '../../models/platform-data-source-query';

export interface PostIchingConsultationsMineQueryDatasource$Params {

/**
 * Optioneel hexagramfilter; een waarde buiten 1..64 geldt als geen filter.
 */
  hexagram?: number | null;
  
    /**
     * Paging, zoeken en optionele sortering.
     */
    body: PlatformDataSourceQuery
}

export function postIchingConsultationsMineQueryDatasource(http: HttpClient, rootUrl: string, params: PostIchingConsultationsMineQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, postIchingConsultationsMineQueryDatasource.PATH, 'post');
  if (params) {
    rb.query('hexagram', params.hexagram, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto>;
    })
  );
}

postIchingConsultationsMineQueryDatasource.PATH = '/api/iching/consultations/mine/query/datasource';
